var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 57 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2122 6.19178C54.8884 4.99501 54.2567 3.90396 53.38 3.02726C52.5034 2.15056 51.4124 1.51881 50.2156 1.19492C45.8343 1.52588e-05 28.2009 1.52588e-05 28.2009 1.52588e-05C28.2009 1.52588e-05 10.5667 0.0361843 6.18535 1.23109C4.98857 1.555 3.89753 2.18679 3.02087 3.06352C2.14421 3.94026 1.51252 5.03136 1.18871 6.22817C-0.136535 14.0129 -0.650623 25.8751 1.2251 33.3484C1.54894 34.5452 2.18064 35.6363 3.0573 36.513C3.93396 37.3897 5.02499 38.0214 6.22174 38.3453C10.6031 39.5402 28.2369 39.5402 28.2369 39.5402C28.2369 39.5402 45.8704 39.5402 50.2516 38.3453C51.4483 38.0214 52.5394 37.3897 53.4161 36.513C54.2928 35.6363 54.9246 34.5452 55.2484 33.3484C56.6462 25.5527 57.0769 13.698 55.2122 6.192V6.19178Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5883 28.2429L37.2165 19.77L22.5883 11.2972V28.2429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.4592,
    height: 39.6979,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.629d6e8414d27e030d85aa0a49d23e2b.svg";
export { ForwardRef as ReactComponent };